<template>
    <div class="page page-test" :style="{height: height}">
        <transition name="fadeIn">
            <div  ref="circleWrapper" class="lines-circle-wrapper" v-show="canAnimate">
                <div ref="circle" class="lines-circle"></div>
            </div>
        </transition>

        <!--<div class="center-point" :style="{position: 'absolute', width: '100%', height: '2px', background: 'green', left: 0, top: `${trgCenterPoint}px`}"></div>-->
        <div ref="wrapperContent" class="test-wrapper">
            <div ref="testContent" class="test-content">
                <transition name="slideLeft">
                    <h1 class="title" v-show="canAnimate">
                        ПРОЙДИ ТЕСТ на&nbsp;знание fifa
                    </h1>
                </transition>

                <transition name="slideRight">
                    <p class="text" v-show="canAnimate">
                        Ответь на&nbsp;10&nbsp;вопросов на&nbsp;время и&nbsp;поборись за&nbsp;приз&nbsp;&mdash; встречу
                        с&nbsp;футболистом в&nbsp;офисе &laquo;Чемпионата&raquo;. Тест обновляется
                        каждую неделю.
                    </p>
                </transition>

                <transition name="slideDown">
                    <router-link to="/test/start" @click.native="Helpers.ga().send('click','Пройти тест')" class="btn" v-show="canAnimate">ПРОЙТИ</router-link>
                </transition>

            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap'
    import Helpers from '@/tools/Helpers'

    export default {
        name: 'Test',
        props: ['canAnimate'],

        data(){
            return{
				Helpers,
                height: '',
                trgCenterPoint: 0,
            }
        },
        computed: {
            showPage(){
				return this.$route.name === 'Test'
            }
        },
        methods:{
            onResize(){
                setTimeout(()=>{
                    let tHeight = parseInt(window.getComputedStyle(this.$refs['testContent']).height);
                    let tContentRect = this.$refs['testContent'].getBoundingClientRect();
                    let wContentRect = this.$refs['wrapperContent'].getBoundingClientRect();
                    let topPos = tContentRect.top - wContentRect.top;
                    let bottomPos = wContentRect.bottom - tContentRect.bottom;

                    let titleCenterPoint = topPos + tHeight/2;
                    let bottomPointDist = wContentRect.bottom - wContentRect.top;
                    let topPointDist = titleCenterPoint - window.innerHeight/2;


                    if (topPos < bottomPos) {
                        return this.height = `${bottomPointDist - topPointDist}px`;
                    }
                    this.height = `${window.innerHeight}px`;
                },120)
            }
        },
        mounted(){
            window.addEventListener('resize', this.r = this.onResize.bind(this));
            setTimeout(()=>{
                let resizeEvent = window.document.createEvent('UIEvents');
                resizeEvent .initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(resizeEvent);
                this.onResize()
            })
        },
        destroyed(){
            window.removeEventListener('resize', this.r);
        },
        components: {
			Helpers
        }
    }
</script>

<style lang="scss" scoped>
    .fadeIn-enter-active,
    .fadeIn-leave-active {
        opacity: 1;
        transition: opacity .8s;
    }

    .fadeIn-enter {
        opacity: 0;
    }

    .fadeIn-leave-to {
        opacity: 0;
    }


    .slideLeft-enter-active,
    .slideLeft-leave-active {
        opacity: 1;
        transition: opacity .8s, transform .8s;
        transform: translate3d(0,0,0);
    }

    .slideLeft-enter {
        opacity: 0;
        transform: translate3d(-100%,0,0);
    }

    .slideLeft-leave-to {
        opacity: 0;
        transform: translate3d(-100%,0,0);
    }

    .slideRight-enter-active,
    .slideRight-leave-active {
        opacity: 1;
        transition: opacity .8s, transform .8s;
        transform: translate3d(0,0,0);
    }

    .slideRight-enter {
        opacity: 0;
        transform: translate3d(100%,0,0);
    }

    .slideRight-leave-to {
        opacity: 0;
        transform: translate3d(100%,0,0);
    }

    .slideDown-enter-active,
    .slideDown-leave-active {
        opacity: 1;
        transition: opacity .8s, transform .8s;
        transform: translate3d(0,0,0);
    }

    .slideDown-enter {
        opacity: 0;
        transform: translate3d(0,100%,0);
    }

    .slideDown-leave-to {
        opacity: 0;
        transform: translate3d(0,100%,0);
    }
</style>


// WEBPACK FOOTER //
// Test.vue?15fa76ca